/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSearchItemModelSearchResultModel } from '../../models/client-search-item-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface ClientSearchClientPost$Json$Params {
      body?: SearchRequestModel
}

export function clientSearchClientPost$Json(http: HttpClient, rootUrl: string, params?: ClientSearchClientPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, clientSearchClientPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>;
    })
  );
}

clientSearchClientPost$Json.PATH = '/Client/SearchClient';
